module.exports = __webpack_public_path__ + "static/lucy-dunn-bd6da52d687936b8a497b27a2c0f565e.jpg";